import D from '../images/error-1231.webp'
const ErrorPage=()=>{
    return <>
    <div className='ErrorContainer'>
        <img src={D}/>
    </div>
    </>
}
export default ErrorPage